import { useState } from 'react';

export function useClipboard() {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = (text: string) =>
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
    });

  const reset = () => setIsCopied(false);

  return { isCopied, copyToClipboard, reset };
}
